// The address of the CivicLift app (CANONICAL_HOST), rendered into a <meta> tag by the layouts
// (CVL-179). Pages without the tag, such as Jest tests, fall back to www.civiclift.com.
export const DEFAULT_PUBLIC_HOST_URL = 'https://www.civiclift.com'

export const publicHostUrl = (): string =>
  document.querySelector<HTMLMetaElement>('meta[name="civiclift-public-host"]')?.content || DEFAULT_PUBLIC_HOST_URL
